import React from 'react';
import styled from "styled-components";

const Loading = ({
  backgroundColor,
  label = 'Loading…',
}) => {

  return (
    <Container style={{ backgroundColor: backgroundColor }}>
      <h2>{label}</h2>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  margin-right: auto;
  margin-left: auto;
  padding: 1rem;
  color: #fff;
`;

export default Loading;
